<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">{{tipo}} de Desempeño Individual</th>
          <th class="text-left">{{valor}}% Ponderacion del Total</th>
          <th class="text-left" @click="calcular()">Calificación</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="co in comobj" :key="co.id">
          <td>{{ co.nombre }}</td>
          <td>{{ co.peso }}%</td>
          <td>{{ co.real }}</td>
        </tr>
        <tr>
          <td>Nota Ponderada</td>
          <td></td>
          <td>{{ notaPon }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
    name: 'calificacion',
    data() {
        return {
            notaPon: 0,
        }
    },
    props:{
        tipo:{
            type: String,
            default: ''
        },
        valor:{
            type: Number,
            default: 0
        },
        comobj:{
            type: Array,
            default: null
        }
    },
    mounted() {
        setTimeout(() => this.calcular(), 2000)
    },
    methods: {
        calcular() {
            let pond = 0
            for(let i = 0; i < this.comobj.length; i++){
                let prom = 0
                let div = 0
                let real = 0
                if(this.comobj[i].calificacionmed_col > 0){
                    real = real + this.comobj[i].calificacionmed_col
                    prom = prom + (this.comobj[i].calificacionmed_col * this.comobj[i].peso) / 100
                    div++
                }
                if(this.comobj[i].calificacionmed_sup > 0){
                    real = real + this.comobj[i].calificacionmed_sup
                    prom = prom + (this.comobj[i].calificacionmed_sup  * this.comobj[i].peso) / 100
                    div++
                }
                if(this.comobj[i].calificacionfin_col > 0){
                    real = real + this.comobj[i].calificacionfin_col
                    prom = prom + (this.comobj[i].calificacionfin_col  * this.comobj[i].peso) / 100
                    div++
                }
                if(this.comobj[i].calificacionfin_sup > 0){
                    real = real + this.comobj[i].calificacionfin_sup
                    prom = prom + (this.comobj[i].calificacionfin_sup  * this.comobj[i].peso) / 100
                    div++
                }
                if(real > 0 && div > 0){
                    this.comobj[i].real = (real / div).toFixed(2)
                    pond = pond + (prom / div)
                }else{
                    this.comobj[i].real = 0
                    pond = 0
                }
            }
        this.notaPon = (pond).toFixed(2)
        },
    },
}
</script>